module.exports = __webpack_public_path__ + "static/img/城堡模型.d1258ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/城堡模型.jpg
// module id = IGGp
// module chunks = 1